import { Platform } from 'react-native';

import { useSuspenseQuery } from '@fhs/client';
import {
  loyaltyHomepageConfigAppQuery,
  loyaltyHomepageConfigWebQuery,
  sanityClient,
} from '@fhs/cms-groq-queries';

export function useLoyaltyHomepageConfigWebQuery() {
  return useSuspenseQuery({
    queryKey: ['loyalty-homepage-config-web'],
    queryFn: async () => {
      const config = await sanityClient.fetch(loyaltyHomepageConfigWebQuery);
      return config;
    },
  });
}

export function useLoyaltyHomepageConfigAppQuery() {
  return useSuspenseQuery({
    queryKey: ['loyalty-homepage-config-app'],
    queryFn: async () => {
      const config = await sanityClient.fetch(loyaltyHomepageConfigAppQuery);
      return config;
    },
  });
}

export const useLoyaltyHomepageConfigQuery = Platform.select({
  web: useLoyaltyHomepageConfigWebQuery,
  default: useLoyaltyHomepageConfigAppQuery,
});
